angular.module('tf.controllers')

    .factory('TaskService',['$rootScope', 'HttpService','Session','StorageService', '$timeout',
        function($rootScope, HttpService, Session, StorageService, $timeout){

        var service = {};

        var TASK_STATUS = {
            PENDING     : "Pending",
            QUEUED      : "Queued",
            INPROGRESS  : "InProgress",
            COMPLETED   : "Completed",
            CANCELLED   : "Cancelled",
            FAILED      : "Failed"
        };

        service.allTasks = [];
        service.showNoTasks = false;

        service.initTasks = function () {
            HttpService.get("farm/" + Session.farm._id + "/task").then(function (res) {
                $rootScope.loader({overlay:true});
                var tasks = res.data;
                if(tasks){
                    StorageService.load("tasksProgress").then(function(storedProgress){
                        service.allTasks = [];
                        var isRemoveCompleted = Session.farm.settings.tasks.remove_completed;
                        for (var i = 0; i < tasks.length; i++) {
                            var storedProgressItem = _.find(storedProgress, {cid: tasks[i].cid});
                            if (storedProgressItem) {
                                tasks[i].progress = storedProgressItem.progress;
                            }
                            if(tasks[i].state === TASK_STATUS.INPROGRESS){
                                tasks[i].state = "In Progress";
                            }
                            tasks[i].created = moment(tasks[i].created_time).format('h:mmA, MMM Do YYYY');

                            if(isRemoveCompleted && tasks[i].state === TASK_STATUS.COMPLETED){
                                service.removeTaskLocally(tasks[i].cid);
                            }else{
                                service.allTasks.push(tasks[i]);
                            }
                        }
                        $rootScope.loader(false);
                        service.showNoTasks = !service.allTasks.length;
                        service.updateRunningTasks();
                        $rootScope.$apply();
                    });
                }
            });
        };

        service.getTasks = function (tasks) {

            service.showNoTasks = false;
            var isRemoveCompleted = Session.farm.settings.tasks.remove_completed;
            StorageService.load("tasksProgress").then( function (storedProgress) {
                service.allTasks = [];
                for (var i = 0; i < tasks.length; i++) {
                    var storedProgressItem = _.find(storedProgress, {cid: tasks[i].cid}) ;
                    if(storedProgressItem){
                        tasks[i].progress = storedProgressItem.progress;
                    }
                    if(tasks[i].state === TASK_STATUS.INPROGRESS){
                        tasks[i].state = "In Progress";
                    }
                    tasks[i].created = moment(tasks[i].created_time).format('h:mmA, MMM Do YYYY');

                    if(isRemoveCompleted && tasks[i].state === TASK_STATUS.COMPLETED){
                        service.removeTaskLocally(tasks[i].cid);
                    }else{
                        service.allTasks.push(tasks[i]);
                    }

                }

                service.showNoTasks = !service.allTasks.length;
                service.updateRunningTasks();
                $rootScope.$apply();
            });


        };

        service.removeTaskLocally = function(cid) {
            var remainingTasks = _.reject(service.allTasks, function(task) {
                return task.cid === cid;
            });
            service.allTasks = remainingTasks;
            service.showNoTasks = !service.allTasks.length;
            service.updateRunningTasks();
        };

        service.removeTask = function (cid) {
            service.showNoTasks = false;
            HttpService.post("farm/" + Session.farm._id + "/task/remove", {cid: cid}).then(function(removedTask){
               if(removedTask.data){
                   var remainingTasks = _.reject(service.allTasks, function(task){
                       return task.cid === removedTask.data.cid;
                   });
                   service.allTasks = remainingTasks;
                   service.showNoTasks = !service.allTasks.length;
                   service.updateRunningTasks();
               }
            });

        };

        service.setStatus = function (task, status, state) {
            if (!task) return;
            var isRemoveCompleted = Session.farm.settings.tasks.remove_completed;
            if (status) {
                var localTask = _.find(service.allTasks, function(localTask) {
                    return localTask.cid === task.cid;
                });
                if (localTask) {
                    localTask.status = status;
                    localTask.state = state === TASK_STATUS.INPROGRESS ? "In Progress" : state;
                    if (task.fid) {
                        localTask.fid = task.fid;
                    }
                    if (task.farmer_name) {
                        localTask.farmer_name = task.farmer_name;
                    }
                }
                service.updateRunningTasks();
                $rootScope.$apply();

                if (isRemoveCompleted && localTask && localTask.state === TASK_STATUS.COMPLETED) {
                    $timeout(function() {
                        service.removeTaskLocally(localTask.cid);
                    }, 750);
                }
            }
        };

        service.updateTaskProgress = function(cid, progress){
            var tasksProgress = [];
            var task = _.find(service.allTasks, function(task){
                return task.cid === cid;
            });
            if(task){
                task.progress = (progress < 1? progress : 1);
                tasksProgress.push({cid: task.cid, progress: task.progress});
            }
            StorageService.store("tasksProgress", tasksProgress);
            $rootScope.$apply();
        };

        service.updateRunningTasks = function (){
            var running = _.filter(service.allTasks, function(task){
                return (task.state !== TASK_STATUS.COMPLETED && task.state !== TASK_STATUS.CANCELLED && task.state !== TASK_STATUS.FAILED);
            });

            $rootScope.runningTasks = running.length;
        };

        return service;
    }])

    .run(['$rootScope','TaskService', function($rootScope, TaskService){
        $rootScope.$on("progress", function(e, message){
            TaskService.updateTaskProgress(message.cid, message.data.progress);
            $rootScope.$apply();
        });
        $rootScope.$on("status", function(e, message) {
            TaskService.setStatus(message.task, message.data.status, message.data.state);
            $rootScope.$apply();
        });
        $rootScope.$on("tasks", function(e, message) {
            TaskService.getTasks(message);
        });
        $rootScope.$on("initTasks", function() {
            TaskService.initTasks();
        });
    }])

    .controller('TaskManagerController', ['$scope','HttpService','TaskService','$timeout','Session','HeaderService', 'Template',
        function ($scope, HttpService, TaskService, $timeout, Session, HeaderService, Template) {

            TaskService.initTasks();
            $scope.taskService = TaskService;

            HeaderService.setName("Task Manager");

            Session.whenReady().then(function(){
                HttpService.get('user/me/tasks',{},true);
            });
            // $timeout(function(){HttpService.get('user/me/tasks',{},true);},0);

            $scope.cancelTask = function (task) {
                HttpService.post('farmer/' + task.fid + '/cancel_task', {cid:task.cid}).then(function (res) {
                    // if(res.data.cid){
                    //     // TaskService.setStatus(res.data, res.data.status);
                    // }
                });
            };

            function reInitializeTask(task){
                task.farmer_name = task.status = '';
                task.state = 'Pending';
            }

            $scope.retryTask = function (task) {
                HttpService.post('farmer/' + task.fid + '/retry_task', {cid:task.cid}).then(function (res) {
                    reInitializeTask(task);
                    // if(res.data.cid){
                    //     // TaskService.setStatus(res.data, res.data.status);
                    // }
                });
            };

            $scope.sortTasks = function(task){
                if(task.state === 'Completed'){
                    return 99999999999 + moment(task.created_time).valueOf();
                }
                // else if(task.state === 'Cancelled'){
                //     return 99999999999999 + moment(task.created_time).unix();
                // }
                else {
                    return moment(task.created_time).valueOf();
                }
            };

            var applyInterval = setInterval(function(){
                $scope.safeApply();
            },1000);

            $scope.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if(phase === '$apply' || phase === '$digest') {
                    if(fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            $scope.showTemplateNames = Session.farm.plan.split_templates;
            $scope.getCurrentTemplateName = function(project){
                var foundIndex = -1;
                var template = _.find(project.templates, function(template, index){
                    if(template.use && !template.render){
                        foundIndex = index;
                        return true;
                    }
                    return false;
                });
                if(template){
                    template = new Template(template);
                    return template.getName(project.name, foundIndex);
                } else {
                    return '';
                }

                // return template? (template.customName || template.name) : '';
            };

            $scope.$on('$destroy', function(){
                clearInterval(applyInterval);
            });

            $scope.debug = false;

        }]);
